import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Aura from "@primeuix/themes/aura";
import "primeicons/primeicons.css";

import App from "./App.vue";
import router from "./router";
import { useAuthStore } from "./stores/auth";
import { useThemeStore } from "./stores/theme";
import "./assets/styles/main.css";

const app = createApp(App);

// Define custom teal theme colors with slate surface scale
const customAura = {
  ...Aura,
  semantic: {
    ...Aura.semantic,
    primary: {
      50: "#e6f7f7",
      100: "#b2d8d8",
      200: "#8fd9d9",
      300: "#66b2b2",
      400: "#4d9f9f",
      500: "#008080",
      600: "#006666",
      700: "#004c4c",
      800: "#003333",
      900: "#001a1a",
      950: "#000d0d"
    },
    colorScheme: {
      light: {
        surface: {
          0: "#ffffff",
          50: "#f8fafc",
          100: "#f1f5f9",
          200: "#e2e8f0",
          300: "#cbd5e1",
          400: "#94a3b8",
          500: "#64748b",
          600: "#475569",
          700: "#334155",
          800: "#1e293b",
          900: "#0f172a",
          950: "#020617"
        }
      },
      dark: {
        surface: {
          0: "#ffffff",
          50: "#f8fafc",
          100: "#f1f5f9",
          200: "#e2e8f0",
          300: "#cbd5e1",
          400: "#94a3b8",
          500: "#64748b",
          600: "#475569",
          700: "#334155",
          800: "#1e293b",
          900: "#0f172a",
          950: "#020617"
        }
      }
    }
  }
};

app.use(PrimeVue, {
  theme: {
    preset: customAura,
    options: {
      darkModeSelector: ".dark",
      cssLayer: false
    }
  }
});
app.use(ToastService);
app.use(ConfirmationService);
app.use(createPinia());
app.use(router);

// Initialize auth state before mounting
const authStore = useAuthStore();
authStore.initAuth();

// Initialize theme before mounting
const themeStore = useThemeStore();
themeStore.initTheme();

app.mount("#app");
